enum BrowseType {
  Gig = "gig",
  Chef = "chef",
}

export default BrowseType;
